import axios from 'axios';
import config from './config';

const USERS_API_URL = `${config.API_BASE_URL}/UsersApi`;

export const fetchUsers = async (userId) => {
  if (!userId) {
    console.log('fetchUsers: No userId, skipping network request.');
    return null;
  }
  try {
    const response = await axios.get(USERS_API_URL);
    return response.data;
  } catch (error) {
    // If not logged in, allow exploring the app
    return null;
  }
};

export const fetchUserById = async (id) => {
  if (!id) return null; // Not logged in, allow exploring
  try {
    const response = await axios.get(`${USERS_API_URL}/${id}`);
    
    // Safety check. If backend returns 200 OK but says user is invalid/deleted.
    if (!response.data || response.data.error || response.data.success === false) {
      console.warn(`User validation returned empty or error for ID ${id}.`);
      return null;
    }

    return response.data;
  } catch (error) {
    // Returning null triggers the Context validation error which shreds the session locally
    console.warn(`User validation failed for ID ${id}. They may have been deleted.`);
    return null;
  }
};

export const updateUser = async (id, user) => {
  if (!id) {
    console.log('updateUser: No userId, skipping network request.');
    return null;
  }
  const response = await axios.put(`${USERS_API_URL}/${id}`, user);
  return response.data;
};

export const deleteUser = async (id) => {
  if (!id) {
    console.log('deleteUser: No userId, skipping network request.');
    return null;
  }
  const response = await axios.delete(`${USERS_API_URL}/${id}`);
  return response.data;
};

// ==================== PASSWORD MANAGEMENT ====================

/**
 * Flow 1: Change password from user profile
 * Requires the user to be logged in (has an ID).
 */
export const changePassword = async (id, data) => {
  if (!id) {
    console.log('changePassword: No userId provided.');
    return null;
  }
  const response = await axios.put(`${USERS_API_URL}/${id}/change-password`, data);
  return response.data;
};

/**
 * Flow 2 - Step 1: Forgot password (Login Screen)
 * Asks for the phone number to send a WhatsApp verification code.
 */
export const forgotPassword = async (phone) => {
  const response = await axios.post(`${USERS_API_URL}/forgot-password`, { Phone: phone });
  return response.data;
};

/**
 * Flow 2 - Step 2: Verify WhatsApp Code
 * Confirms the 6-digit code sent to the user's WhatsApp.
 */
export const verifyResetCode = async (phone, code) => {
  const response = await axios.post(`${USERS_API_URL}/verify-reset-code`, { 
    Phone: phone, 
    Code: code 
  });
  return response.data;
};

/**
 * Flow 2 - Step 3: Set New Password
 * Sets the new password after successfully verifying the code.
 */
export const resetPassword = async (data) => {
  const response = await axios.post(`${USERS_API_URL}/reset-password`, data);
  return response.data;
};